import { render } from "./annualReport.vue?vue&type=template&id=17fd9d54&scoped=true"
import script from "./annualReport.vue?vue&type=script&lang=js"
export * from "./annualReport.vue?vue&type=script&lang=js"

import "./annualReport.vue?vue&type=style&index=0&id=17fd9d54&scoped=true&lang=css"

import exportComponent from "D:\\Developpement\\HATPLC\\frontend 25122025\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17fd9d54"]])

export default __exports__